module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"news":"News","show-more-news":"Show more news"},"pt":{"news":"Notícias","show-more-news":"Mostrar mais notícias"},"es":{"news":"Noticias","show-more-news":"Mostrar más noticias"}}')
  delete Component.options._Ctor
}
